import { useEffect } from 'react'
import { getBottomPadding } from '../../../../../utils/sessionStorage'
import { useToast } from '../../../../../state-management/contexts/ToastContext'
import { EventNames } from '../../../../../types/misc.types'
import { trackEvent } from '../../../../../utils/appBridge'
import { PlansLumpsumListScreenByPlanMode } from '../../analytics/plansEvents'
import { PlansPlanMode } from '../api/types'
import { AllocationPageContent } from './AllocationPageContent'
import { IdealPageContent } from './IdealPageContent'
import { RebalancePageContent } from './RebalancePageContent'
import { LumpsumPlansTopHeader } from './topHeader/LumpsumPlansTopHeader'
import { LumpsumPlansProvider, useLumpsumPlansContext } from './LumpsumPlansProvider'

const SCROLL_PANEL_CLASS_NAME =
  'absolute inset-0 min-h-0 overflow-y-auto overflow-x-hidden no-scrollbar overscroll-none bg-[#F0F4F7]'

const SCROLL_PANEL_STYLE = {
  overscrollBehavior: 'none' as const,
  overflowAnchor: 'none' as const,
  WebkitOverflowScrolling: 'auto' as const,
  touchAction: 'pan-y' as const
}

export default function LumpsumPlansPage() {
  return (
    <LumpsumPlansProvider>
      <LumpsumPlansPageContent />
    </LumpsumPlansProvider>
  )
}

function LumpsumPlansPageContent() {
  const { planMode } = useLumpsumPlansContext()
  const { showToast } = useToast()
  const isRebalanceActive = planMode === PlansPlanMode.REBALANCE
  const isAllocationActive = planMode === PlansPlanMode.ALLOCATION
  const isIdealActive = planMode === PlansPlanMode.IDEAL_PORTFOLIO

  useEffect(() => {
    trackEvent({
      eventName: EventNames.ScreenLoaded,
      payload: {
        ScreenName: PlansLumpsumListScreenByPlanMode?.[planMode]
      }
    })
  }, [planMode])


  return (
    <div
      className="relative h-screen flex flex-col min-h-0 overflow-hidden bg-white"
      style={{
        paddingBottom: `calc(${getBottomPadding()}px)`
      }}
    >
      <LumpsumPlansTopHeader />
      {/* One scroll container per underline tab, all kept mounted. `invisible` preserves each
          panel's scrollTop; `hidden` (display:none) would reset it on every tab switch. */}
      <div className="relative flex-1 min-h-0 overflow-hidden">
        <div
          className={`${SCROLL_PANEL_CLASS_NAME} ${isRebalanceActive ? 'z-[1]' : 'invisible pointer-events-none z-0'}`}
          style={SCROLL_PANEL_STYLE}
          aria-hidden={!isRebalanceActive}
        >
          <RebalancePageContent />
        </div>
        <div
          className={`${SCROLL_PANEL_CLASS_NAME} ${isAllocationActive ? 'z-[1]' : 'invisible pointer-events-none z-0'}`}
          style={SCROLL_PANEL_STYLE}
          aria-hidden={!isAllocationActive}
        >
          <AllocationPageContent />
        </div>
        <div
          className={`${SCROLL_PANEL_CLASS_NAME} ${isIdealActive ? 'z-[1]' : 'invisible pointer-events-none z-0'}`}
          style={SCROLL_PANEL_STYLE}
          aria-hidden={!isIdealActive}
        >
          <IdealPageContent />
        </div>
      </div>
    </div>
  )
}
